<template>
  <div id="top">
    <headNav :gray="gray"></headNav>
    <!--container-->
    <div class="innerWrapper">
      <h1>Terms and Conditions</h1>
      <h2>
        This Website and its contents are owned or licensed by Unifi Property
        Pty Ltd (ACN 638 376 977) (<span class="bold">Unifi, we, us</span> or
        <span class="bold">our</span>).
      </h2>
      <h3>AGREEMENT TO TERMS AND CONDITIONS</h3>
      <h2>
        To the maximum extent permitted by law, these terms and conditions
        govern the use of this Website, the placement of any Reservations and
        the purchase of any Services via this Website. We may amend these Terms
        and Conditions from time to time and if any part of them is illegal or
        unenforceable at law, it may be severed and the remaining Terms and
        Conditions will continue in full force and effect.
      </h2>
      <h3>AMENDMENTS TO THESE TERMS AND CONDITIONS</h3>
      <h2>
        For future orders of our Services and Reservations that You place with
        us, these Terms and Conditions may be different. We recommend that you
        read these Terms and Conditions carefully each time You visit our
        Website, order our Services or place a Reservation. We will not change
        any Terms and Conditions for an existing Services order or a Reservation
        that we have accepted; the Terms and Conditions that will apply to the
        Reservation or Service are the Terms and Conditions that applied at the
        time You placed the Reservation or ordered the Service.
      </h2>
      <h3>DEFINITIONS</h3>
      <h2>In these Terms and Conditions:</h2>
      <h2>
        <span class="bold">Available Properties</span> means residential or
        commercial properties offered for sale Prospective Property Purchasers
        by Varo Property Services or its Co-Agents, as agents of the registered
        proprietors of those properties.
      </h2>
      <h2>
        <span class="bold">Claim</span> means any claim, action, proceeding,
        loss, damage, suit, cause of action, demand, cost, expense or liability,
        brought, made or recovered against a person, howsoever arising, whether:
      </h2>
      <h4><span class="word">(a)</span> in contract, tort or otherwise; or</h4>
      <h4>
        <span class="word">(b)</span> presently ascertained, immediate, future
        or contingent.
      </h4>
      <h2>
        <span class="bold">Co-Agent</span> means a third party agent who has
        been appointed to sell or otherwise deal with an Available Property on
        behalf of the registered proprietor.
      </h2>
      <h2>
        <span class="bold">Commercialise</span> in relation to Intellectual
        Property Rights, means to:
      </h2>
      <h4>
        <span class="word">(a)</span>manufacture, sell, hire or otherwise
        exploit a product or process, that incorporates any of the Intellectual
        Property Rights;
      </h4>
      <h4>
        <span class="word">(b)</span>provide a service using any of those
        Intellectual Property Rights;
      </h4>
      <h4>
        <span class="word">(c)</span>license any third party to do any of those
        things,
      </h4>
      <h2>regardless of whether any revenue is generated.</h2>
      <h2>
        <span class="bold">Confidential Informatio</span> means information
        concerning Unifi or any of its Related Bodies Corporate (including Varo
        Property Services), including details of:
      </h2>
      <h4>
        <span class="word">(a)</span>any past, current or prospective purchasers
        of residential or commercial properties;
      </h4>
      <h4>
        <span class="word">(b)</span>any suppliers, contractors or agents;
      </h4>
      <h4>
        <span class="word">(c)</span>business dealings, methodologies, marketing
        techniques or market analysis;
      </h4>
      <h4>
        <span class="word">(d)</span>financial arrangements with purchasers,
        suppliers, contractors or agents;
      </h4>
      <h4>
        <span class="word">(e)</span>information disclosed on the Property
        Platform; and
      </h4>
      <h4>
        <span class="word">(f)</span>any other information that is by its nature
        confidential, is reasonably designated by Unifi as confidential or which
        You know or ought to know is confidential,
      </h4>
      <div class="bigindent">
        <h2>but does not include information:</h2>
        <h4>
          <span class="word">(i)</span>in the public domain, unless it came into
          the public domain due to a breach of these Terms and Conditions or
          some other obligation of confidentiality;
        </h4>
        <h4>
          <span class="word">(ii)</span>that is already lawfully in Your
          possession without restriction, before it was disclosed by Unifi; or
        </h4>
        <h4>
          <span class="word">(iii)</span>that You obtained lawfully from a third
          party, without any breach of confidentiality.
        </h4>
      </div>
      <h2>
        <span class="bold">GST</span> means the tax payable on taxable supplies
        under the
        <span class="souwai"
          >A New Tax System (Goods and Services Tax) Act 1999</span
        >
        (Cth), including any subordinate legislation.
      </h2>
      <h2>
        <span class="bold">Intellectual Property Rights</span> means all
        industrial and intellectual property rights anywhere in the world,
        whether registered or unregistered, including patent rights, trade mark
        rights, copyright (but excluding Moral Rights), plant breeders' rights
        and rights in relation to inventions, trade names, business names,
        company names, indications of origin, designs, plant varieties,
        semiconductors, circuit layouts, confidential information or know-how,
        any right of registration, renewal and extension of such rights and all
        other intellectual property as defined in article 2 of the
        <span class="souwai"
          >Convention Establishing the World Intellectual Property Organisation
          1967</span
        >.
      </h2>
      <h2>
        <span class="bold">Moral Rights</span> means moral rights as described
        in Part IX of the <span class="souwai">Copyright Act 1968</span>
        (Cth) and any analogous rights arising under statute that exist, or may
        come to exist, anywhere in the world.
      </h2>
      <h2>
        <span class="bold">Personal Information</span> means information or an
        opinion about an identified individual, or information from which an
        individual could reasonably be identified. This is regardless of whether
        the information or opinion is true, and whether or not it is stored in a
        material or intangible form.
      </h2>
      <h2>
        <span class="bold">Privacy Policy</span> means the privacy policy of
        Unifi as displayed on this Website from time to time.
      </h2>
      <h2>
        <span class="bold">Property Platform</span>means the electronic platform
        which allows Referral Partners with a valid Referral Account to access
        information on Available Properties, including:
      </h2>
      <h4><span class="word">(a)</span>purchase prices;</h4>
      <h4>
        <span class="word">(b)</span>dimensions, land size and floor plans; and
      </h4>
      <h4>
        <span class="word">(c)</span>a description of the Available Property
        features.
      </h4>
      <h2>
        <span class="bold">Prospective Property Purchaser</span> means an
        individual or entity interested in obtaining details of the Available
        Properties, with a view to a possible purchase of one or more of them.
      </h2>
      <h2>
        <span class="bold">Referral Account</span> means an online record of
        information:
      </h2>
      <h4><span class="word">(a)</span>created by a Referral Partner;</h4>
      <h4>
        <span class="word">(b)</span>containing the company name, Australian
        Business Number, street or PO Box address, email address and telephone
        number of the Referral Partner; and
      </h4>
      <h4>
        <span class="word">(c)</span>which permits the Referral Partner to
        access details of Available Properties and to place orders for Services.
      </h4>
      <h2>
        <span class="bold">Referral Partner</span> means a third party that may
        refer Prospective Property Purchasers to Varo Property Services or its
        Co-Agent.
      </h2>
      <h2>
        <span class="bold">Related Bodies Corporate</span> has the same meaning
        as set out in the
        <span class="souwai">Corporations Act 2001</span> (Cth).
      </h2>
      <h2>
        <span class="bold">Reservation</span> means an agreement formed upon
        processing of the Reservation Fee, under which a Prospective Property
        Purchaser reserves an Available Property from viewing by other Referral
        Partners on the Property Platform, for the Reservation Period.
      </h2>
      <h2>
        <span class="bold">Reservation Fee</span> means the fee paid by or on
        behalf of a Prospective Property Purchaser to secure a Reservation.
      </h2>
      <h2>
        <span class="bold">Reservation Period</span> means a period of seven (7)
        days from the payment of the Reservation Fee, or such longer period as
        may be agreed between You and Unifi.
      </h2>
      <h2><span class="bold">Services</span> means any of:</h2>
      <h4><span class="word">(a)</span>a Reservation;</h4>
      <h4>
        <span class="word">(b)</span>training materials, modules or activities
        accessible from our Website from time to time; and
      </h4>
      <h4>
        <span class="word">(c)</span>(c)any other services which may be
        purchased or made available from this Website from time to time.
      </h4>
      <h2>
        <span class="bold">Terms and Conditions</span> means these terms and
        conditions as may be amended from time to time.
      </h2>
      <h2>
        <span class="bold">Third Party Fees</span> means the fees described in
        paragraph (f) of the PLACEMENT OF RESERVATIONS AND PURCHASE OF OTHER
        SERVICES FROM OUR WEBSITE section of these Terms and Conditions.
      </h2>
      <h2>
        <span class="bold">Varo Property Services</span> means Varo Property
        Services Pty Ltd ACN 140 366 543.
      </h2>
      <h2>
        <span class="bold">Website</span> means the website situated at [<span
          class="red"
          >insert website address</span
        >] and includes the Property Platform.
      </h2>
      <h2>
        <span class="bold">You</span> means any of a Referral Partner or other
        third party that accesses our Website, as the context requires and
        <span class="bold">Your</span> or <span class="bold">Yourself</span> has
        a corresponding meaning.
      </h2>
      <h3>USE OF THIS WEBSITE</h3>
      <h2>You may only use this Website if You:</h2>
      <h4><span class="word">(a)</span>have a valid Referral Account;</h4>
      <h4><span class="word">(b)</span>are aged 18 years or over;</h4>
      <h4>
        <span class="word">(c)</span>are authorised by Prospective Property
        Purchasers to create a Reservation of Available Properties on their
        behalf; and
      </h4>
      <h4>
        <span class="word">(d)</span>agree to be bound by, and accept, these
        Terms and Conditions.
      </h4>
      <h2>
        Please immediately exit this Website if You do not satisfy these
        requirements.
      </h2>
      <h3>
        PLACEMENT OF RESERVATIONS AND PURCHASE OF OTHER SERVICES FROM OUR
        WEBSITE
      </h3>
      <h2>You agree that:</h2>
      <h4>
        <span class="word">(a)</span>both You and any Prospective Property
        Purchaser for whom you act are aged 18 years or over;
      </h4>
      <h4>
        <span class="word">(b)</span>if You place a Reservation or an order for
        Services on our Website, You enter into a contract with Unifi for the
        supply of the Reservation or those Services. Each accepted order is a
        separate contract;
      </h4>
      <h4>
        <span class="word">(c)</span>we can accept or reject a Reservation or
        order for Services for reasons which include unavailability of the
        Available Properties or Services (as the case may be), an error in the
        pricing or description of the Available Properties or Services, or an
        error in Your Reservation or order for the Services;
      </h4>
      <h4><span class="word">(d)</span></h4>
      <div class="bigindent">
        <h4><span class="word">(i)</span>creating a Referral Account;</h4>
        <h4><span class="word">(ii)</span>placing a Reservation; or</h4>
        <h4><span class="word">(iii)</span>ordering any Services,</h4>
        <h2>
          must be accurate, complete and up to date, and You will promptly
          notify us of any changes to this information or data;
        </h2>
      </div>
      <h4>
        <span class="word">(e)</span>all prices quoted for the Reservation Fee
        or Services are displayed in Australian Dollars (AUD) and are inclusive
        of GST;
      </h4>
      <h4>
        <span class="word">(f)</span>once You have placed Your Reservation or
        order for Services, You may effect payment by either Mastercard or Visa.
        We will send You a tax invoice / receipt to Your nominated email address
        when Your payment has been processed. Please note that by using the
        payment facilities provided by third party e-commerce facilities or
        credit card merchants, You will be subject to additional terms,
        conditions, fees and charges imposed by those third parties;
      </h4>
      <h4>
        <span class="word">(g)</span>the payment system on this Website uses
        industry standard Secure Socket Layer (SSL) technology to encrypt and
        protect Your credit card details [<span class="red"
          >TO BE CONFIRMED WITH ELECTRONIC PAYMENT GATEWAY PROVIDER</span
        >];
      </h4>
      <h4>
        <span class="word">(h)</span>we will provide Your Reservation or
        Services after Your payment has been processed. For the avoidance of
        doubt, we do not offer for sale, or sell Available Properties, but
        simply make them available for viewing on our Property Platform;
      </h4>
      <h4>
        <span class="word">(i)</span>we will use our reasonable endeavours to
        ensure that Available Properties are available for purchase or Services
        are available for delivery, and in most cases will notify You if
        Available Properties are no longer available before You place Your
        Reservation, or Services are unavailable before You order them. In some
        cases, this will not be possible and we will need to reject a
        Reservation for Available Properties or an order for Services after we
        have processed Your payment. In these cases, we will refund You in full
        all amounts You have paid for the Reservation or unavailable Services,
        less the Third Party Fees;
      </h4>
      <h4>
        <span class="word">(j)</span>if you cancel Your Reservation before the
        Reservation Period expires, we will refund the Reservation Fee to You,
        less the Third Party Fees;
      </h4>
      <h4>
        <span class="word">(k)</span>if You or a Prospective Property Purchaser
        executes a contract for the sale of land with the registered proprietor
        of an Available Property, the Reservation Fee will be applied in part
        payment of the purchase price; and
      </h4>
      <h4>
        <span class="word">(l)</span>once the Services have been delivered, You
        assume all risk and title in the Services.
      </h4>
      <h3>YOUR REFERRAL ACCOUNT</h3>
      <h2>
        When placing Reservations or purchasing Services via this Website, You
        will need to create a Referral Account with us.
      </h2>
      <h2>To create a Referral Account, You must:</h2>
      <h4>
        <span class="word">(a)</span>be aged 18 years or over and have the
        capacity to enter into a binding legal agreement to create a Referral
        Account with us;
      </h4>
      <h4>
        <span class="word">(b)</span>provide us with, amongst other matters,
        Your company name, Australian Business Number, street or PO Box address,
        email address and telephone number. All Personal Information that we
        receive from You is handled in accordance with the practices set out in
        our Privacy Policy which is accessible from this Website; and
      </h4>
      <h4>
        <span class="word">(c)</span>create a password and username at the time
        that You register a Referral Account with us. You are responsible for
        maintaining the security of Your username and password. If You suspect
        that Your account has been subject to unauthorised access, You must
        contact us immediately and take reasonable steps to secure Your account,
        such as changing Your password. We are not liable for any Claims
        howsoever arising from the unauthorised use of Your password or
        username.
      </h4>
      <h2>
        We reserve the right to terminate or suspend Your account in the event
        that you breach these Terms and Conditions.
      </h2>
      <h3>YOUR PERSONAL INFORMATION AND PRIVACY</h3>
      <h2>
        Our Privacy Policy [<span class="red">insert link</span>] sets out the
        ways in which we may collect, store, use and manage Your Personal
        Information, and the physical and electronic measures we will take to
        protect Your Personal Information.
      </h2>
      <h2>
        By supplying us with Personal Information through this Website, You
        accept the inherent security risk of dealings online over the internet
        and agree not to hold us responsible for any breach of security, unless
        we have breached a law or been in wilful default of our duties to You.
      </h2>
      <h3>OUR INTELLECTUAL PROPERTY RIGHTS</h3>
      <h2>
        Unless expressly stated otherwise, we own or are licensed to use all
        Intellectual Property Rights in this Website and its content. You may
        only use that content with our express written consent or as permitted
        under applicable Australian and international laws. If we allow You to
        use any of the content appearing on this Website, our status as the
        owner or licensee of the Intellectual Property Rights in that content
        must be publicly acknowledged in writing, as we may direct. In that
        respect, You must not:
      </h2>
      <h4>
        <span class="word">(a)</span>adapt, modify, reproduce or transmit any of
        the Website content (including its graphics, layouts and format) without
        our prior written consent;
      </h4>
      <h4>
        <span class="word">(b)</span>frame our Website content within Your own
        website, without our prior written consent;
      </h4>
      <h4>
        <span class="word">(c)</span>download our Website content for any
        purpose other than referring Prospective Property Purchasers to Varo
        Property Services or its Co-Agent.
      </h4>
      <h2>
        We do not own or license, and we take no responsibility for trade marks,
        logos, design and copyright material appearing in:
      </h2>
      <h4>
        <span class="word">(a)</span>any third party websites which may be
        accessible from links displayed on our Website; or
      </h4>
      <h4><span class="word">(b)</span>content that You provide to us.</h4>
      <h3>CONFIDENTIAL INFORMATION</h3>
      <h2>
        Some sections of this Website, including the Property Platform, contain
        Confidential Information. By accessing this Website, You acknowledge and
        agree that:
      </h2>
      <h4>
        <span class="word">(a)</span>(a)we are providing You with access to the
        Confidential Information to facilitate Your referral of Prospective
        Property Purchasers to Varo Property Services or its Co-Agents;
      </h4>
      <h4>
        <span class="word">(b)</span>You will not use or disclose the
        Confidential Information for any other purpose, including to:
      </h4>
      <div class="bigindent">
        <h4>
          <span class="word">(i)</span>improperly gain an advantage for Yourself
          or someone else;
        </h4>
        <h4>
          <span class="word">(ii)</span>cause detriment to Unifi, Varo Property
          Services or its Co-Agent;
        </h4>
        <h4>
          <span class="word">(iii)</span>solicit, canvass or approach any of the
          registered proprietors of the Available Properties, so as to induce
          them to cease the appointment of Varo Property Services or its
          Co-Agent;
        </h4>
        <h4>
          <span class="word">(iv)</span>interfere with the relationship between
          registered proprietors of the Available Properties and Varo Property
          Services or its Co-Agent; and
        </h4>
      </div>
      <h4>
        <span class="word">(c)</span>the restrictions and prohibitions outlined
        in this section are reasonable in the circumstances and necessary to
        protect the goodwill in Unifi's, Varo Property Services' and its
        Co-Agent's business; and
      </h4>
      <h4>
        <span class="word">(d)</span>(d)monetary damages alone are not an
        adequate remedy for breach of this section and Unifi may apply for
        injunctive relief if You breach or threaten to breach this section.
      </h4>
      <h3>CONTENT WE PROVIDE</h3>
      <h2>
        Unless stated otherwise, we grant to You a personal, non-transferable,
        revocable and non-exclusive licence to use any files that we expressly
        state is available for download on this Website, for Your own personal
        use. Unless permitted by a written agreement between You and us, You
        must not copy, communicate to the public, modify, reverse engineer, or
        otherwise transfer any right in those files.
      </h2>
      <h2>
        We cannot guarantee that information (including any file) obtained from
        this Website is free from computer viruses, other faults or defects. It
        is Your responsibility to scan the information for computer viruses and
        You assume the risk of any damage to Your computer and associated
        equipment arising from the use of this Website or the downloading of any
        files from it.
      </h2>
      <h3>CONTENT YOU PROVIDE</h3>
      <h2>
        You are fully responsible for any content (including any testimonials,
        comments, suggestions, graphics or other material) that You provide to
        us for display on the Website. By providing content to us, You grant us
        a licence to use that content without payment or reference to You, for
        purposes which include advertising or marketing our own business and
        services.
      </h2>
      <h2>
        You agree that You will not use this Website to post or display content
        that:
      </h2>
      <h4>
        <span class="word">(a)</span>You do not have the right to post or
        display;
      </h4>
      <h4>
        <span class="word">(b)</span>violates the Intellectual Property Rights,
        confidentiality, privacy or other rights of any person or entity;
      </h4>
      <h4>
        <span class="word">(c)</span>violates consumer protection or fair
        trading laws;
      </h4>
      <h4>
        <span class="word">(d)</span>is offensive, abusive, defamatory,
        discriminatory, false or misleading;
      </h4>
      <h4>
        <span class="word">(e)</span>comprises advertising or promotional
        materials of any kind; or
      </h4>
      <h4>
        <span class="word">(f)</span>contains software viruses or anything
        harmful to this Website or to the computers, mobile devices or
        associated equipment of other users of this Website.
      </h4>
      <h2>
        We reserve the right to edit or remove any of Your content at any time,
        without providing any reasons.
      </h2>
      <h3>LINKS TO EXTERNAL WEBSITES</h3>
      <h2>
        Our Website may contain links to Websites or advertisements of goods and
        services available from third parties. We are not responsible for the
        content of those Websites or advertisements, or any goods or services
        made available on them.
      </h2>
      <h3>SOCIAL MEDIA</h3>
      <h2>
        We maintain a presence on
        <span class="souwai">Facebook, Instagram, LinkedIn and Twitter</span>
        but are not endorsed by, or affiliated with, those organisations (<span
          class="bold"
          >Social Media Accounts</span
        >). We reserve the right to remove any material that is posted on the
        pages of our Social Media Accounts that:
      </h2>
      <h4>
        <span class="word">(a)</span>is abusive, defamatory, offensive or
        threatening towards us, our employees or any other person or
        organisation;
      </h4>
      <h4>
        <span class="word">(b)</span>breaches the terms and conditions of any of
        the providers of the Social Media Accounts;
      </h4>
      <h4>
        <span class="word">(c)</span>constitutes spruiking or other advertising,
        unless written consent has been obtained from us to post such material;
        or
      </h4>
      <h4><span class="word">(d)</span>relates to any illegal activity.</h4>
      <h2>
        Please note that You will be subject to, and agree to comply with, the
        respective terms and conditions imposed by
        <span class="souwai">Facebook, Instagram, LinkedIn</span> and Twitter
        whilst You are visiting any of our Social Media Accounts and it remains
        Your responsibility to familiarise Yourself with those terms and
        conditions.
      </h2>
      <h2>
        <span class="bold">[</span
        ><span class="red bold"
          >Our Website contains an embedded Twitter timeline of all:</span
        >
      </h2>
      <h2>
        <span class="word red bold">(a)</span
        ><span class="red bold">[insert]; and</span>
      </h2>
      <h2>
        <span class="word red bold">(b)</span
        ><span class="red bold"
          >re-tweets of Twitter users who reference @[insert].</span
        >
      </h2>
      <h2>
        <span class="red bold"
          >By embedding a Twitter timeline on our Website, Twitter is granted a
          non-exclusive, royalty free licence to access, index and cache this
          Website by any means, including web spiders and/or crawlers.
        </span>
      </h2>
      <h2>
        <span class="red bold"
          >Twitter's use of cookies may involve the storing and accessing of
          cookies or other information on Your devices, as described in
          Twitter's Cookie Use Policy. You should consider Twitter's Cookies Use
          Policy before using our Website, which can be viewed via:
          https://help.twitter.com/en/rules-and-policies/twitter-cookies</span
        >
      </h2>
      <h2>
        <span class="red bold"
          >Twitter's use of cookies may result in Twitter collecting and storing
          data about Your browsing activities, including for interest based
          advertising. By proceeding to use our Website, You consent to
          Twitter's use of cookies. You may opt out of Twitter's interest-based
          advertising and personalisation in accordance with the instructions
          contained in its Twitter for Websites — ads info and privacy document,
          accessible via:
          https://help.twitter.com/en/twitter-for-Websites-ads-info-and-privacy</span
        ><span class="bold"></span>]
      </h2>
      <h3>LIMITATION OF LIABILITY</h3>
      <h2>
        To the maximum extent permitted by law, including the Australian
        Consumer Law:
      </h2>
      <h4>
        <span class="word">(a)</span>we provide this Website on an “as is”
        basis. We may suspend access to our Website or close it indefinitely
        without notice and You accept the inherent security and reliability
        risks of dealings on the internet;
      </h4>
      <h4>
        <span class="word">(b)</span>we are not liable for loss of revenue, loss
        of actual or anticipated profits, loss of business or indirect and
        consequential losses;
      </h4>
      <h4>
        <span class="word">(c)</span>we are not liable for a breach of our
        obligations under these Terms and Conditions which has resulted from
        causes beyond our reasonable control. Those causes include extreme
        weather conditions, government restrictions, declared epidemics or
        pandemics, industrial strikes and failure of equipment or machinery,
        including failure of the internet; and
      </h4>
      <h4>
        <span class="word">(d)</span>subject to the Australian Consumer Law (and
        without excluding any mandatory statutory guarantees contained within
        the Australian Consumer Law or other statutory rights which cannot be
        excluded by contract) all conditions, warranties and implied terms are
        excluded from these Terms and Conditions. To the extent that we breach
        these Terms and Conditions and it is legally permissible to do so, our
        liability is limited to:
      </h4>
      <div class="bigindent">
        <h4>
          <span class="word">(i)</span>replacement of the Services supplied or
          supply of equivalent Services;
        </h4>
        <h4>
          <span class="word">(ii)</span>payment of the cost of replacing the
          Services or acquiring equivalent Services;
        </h4>
        <h4><span class="word">(iii)</span>supply of the Services again; or</h4>
        <h4>
          <span class="word">(iv)</span>in the case of Reservations, a refund of
          the Reservation Fee, less the Third Party Fees.
        </h4>
      </div>
      <h2>
        We will take all reasonable steps to ensure that this Website is
        accurate, but make no representation as to the appropriateness of it for
        Your personal circumstances.
      </h2>
      <h3>NOTICES</h3>
      <h2>
        We may give notice to You by electronic mail or by regular mail to the
        address contained in Your Referral Account or other information You have
        provided. Our  Privacy Policy explains how You can opt-out of receiving
        such notices.
      </h2>
      <h3>GOVERNING LAW</h3>
      <h2 style="margin-bottom:80px">
        The laws of South Australia, Australia, govern these Terms and
        Conditions and the courts of South Australia have non-exclusive
        jurisdiction to hear any matters arising from or in connection with
        these Terms and Conditions.
      </h2>
    </div>
    <!--footer-->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";

export default {
  data() {
    return {
      showTitle: false,
      gray: true
    };
  },
  components: {
    headNav,
    footNav
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  }
};
</script>

<style id="top" lang="scss" scoped>
.innerWrapper {
  width: 100%;
  padding: 1.04rem 0 0 0;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 1.04rem 0.24rem 0 0.24rem;

  h1 {
    font-size: 0.56rem;
    line-height: 0.68rem;
    color: #2a2929;
    margin-bottom: 0.32rem;
    font-family: ProximaNova-Semibold;
    padding-top: 0.48rem;
    box-sizing: border-box;
  }

  .bigindent {
    box-sizing: border-box;
    width: 100%;
    padding-left: 0.3rem;
  }

  h2 {
    font-size: 0.28rem;
    margin-bottom: 0.4rem;
    line-height: 0.42rem;
    color: #3f3f46;

    i {
      font-style: italic;
      font-family: ProximaNova-Semibold;
    }

    .souwai {
      font-style: italic;
    }

    .red {
      color: #ff1300;
    }

    .num {
      margin-right: 0.1rem;
      position: relative;
      top: 0.03rem;
    }

    .word {
      margin-right: 0.1rem;
    }

    .bold {
      font-family: ProximaNova-Semibold;
    }
  }

  .wai {
    font-style: italic;
  }

  h3 {
    font-size: 0.3rem;
    font-family: ProximaNova-Semibold;
    margin-bottom: 0.3rem;
    line-height: 0.5rem;
    color: #3f3f46;
  }

  h4 {
    font-size: 0.28rem;
    margin-bottom: 0.4rem;
    line-height: 0.42rem;
    color: #3f3f46;
    width: 100%;
    display: flex;
    flex-direction: row;

    .num {
      margin-right: 0.1rem;
      position: relative;
      flex: 0 0 auto;
    }

    .souwai {
      font-style: italic;
      flex: 0 0 auto;
    }

    .word {
      margin-right: 0.1rem;
      flex: 0 0 auto;
    }
  }

  p {
    font-size: 0.28rem;
    margin-bottom: 0.36rem;
    line-height: 0.42rem;
    color: #3f3f46;
    word-break: break-word;
    padding: 0 0.24rem;
    box-sizing: border-box;
    padding-left: 0.58rem;
    position: relative;

    .red {
      color: #ff1300;
    }
  }

  p:after {
    content: "";
    display: block;
    position: absolute;
    left: 0.16rem;
    top: 40%;
    border-radius: 50%;
    width: 0.12rem;
    height: 0.12rem;
    background: rgba(0, 0, 0, 1);
  }

  .suojin {
    padding-left: 1rem;
  }

  .suojin:after {
    left: 0.56rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/more/term2.vue